export default __webpack_public_path__ + "static/media/maps.a0de8ee4.svg";